import React, { useState, useMemo, useEffect } from 'react';
import { Calendar, Badge, Tabs, Modal, Form, Spin, message, Select, Table, Button } from 'antd';
import { Header } from '../../../../components';
import { UseFetchSchedule,UseFetchCreateLeaveDay,UseFetchListLeaveDay } from '../hooks/useFetch';
import moment from 'moment';
import TableHoliday from '../components/tableHoliday';
import HolidayModal from '../components/holidayModal';
import dayjs from 'dayjs';


function SchedulePage() {
  const [activeTab, setActiveTab] = useState('day');
  const [selectMonthDay, setSelectMonthDay] = useState(dayjs().format('YYYY-MM'));
  const [selectMonthNight, setSelectMonthNight] = useState(dayjs().format('YYYY-MM'));
  const [selectMonthMix, setSelectMonthMix] = useState(dayjs().format('YYYY-MM'));
  const [selectMonth , setSelectMonth] = useState(dayjs().format('YYYY-MM'));
  const { data: allHolidays = [], isLoading, refetch: refetchSchedule } = UseFetchSchedule(selectMonth);
  const { data: listLeaveDay = [], isLoading: isLoadingListLeaveDay, refetch: refetchListLeaveDay } = UseFetchListLeaveDay();
  const { mutateAsync: createLeaveDay } = UseFetchCreateLeaveDay();
  

  //Holiday Modal
  const [isHolidayModalOpen, setIsHolidayModalOpen] = useState(false);

  const refresh = () => {
    refetchSchedule();
    refetchListLeaveDay();
  }

  // holidays คือ array ที่ได้จาก API (วันหยุดของพนักงาน)
  const calendarData = useMemo(() => {
    const map = {};
    allHolidays.forEach(item => {
      const dateStr = moment(item.date).format('YYYY-MM-DD');
      // ตรวจสอบ shift ให้ตรงกับ activeTab (2 = day, 3 = night, 4 = afternoon)
      let shiftValue;
      if (activeTab === 'day') shiftValue = '2';
      else if (activeTab === 'night') shiftValue = '3';
      else if (activeTab === 'afternoon') shiftValue = '4';

      if (String(item.shift) === shiftValue) {
        if (!map[dateStr]) map[dateStr] = [];
        map[dateStr].push(item);
      }
    });
    return map;
  }, [allHolidays, activeTab]);

  useEffect(() => {
    if (activeTab === 'day') {
      setSelectMonth(selectMonthDay);
    } else if (activeTab === 'night') {
      setSelectMonth(selectMonthNight);
    } else if (activeTab === 'afternoon') {
      setSelectMonth(selectMonthMix);
    }
  }, [activeTab,selectMonthDay,selectMonthNight,selectMonthMix]);  

  useEffect(() => {
    refetchSchedule();
  }, [selectMonth]);
  // แสดงข้อมูลใน cell ของปฏิทิน (แสดงรายชื่อคนที่หยุด)
  const dateCellRender = (value) => {
    const dateStr = value.format('YYYY-MM-DD');
    const items = calendarData[dateStr] || [];
    return (
      <div style={{ minHeight: 40 }}>
        {items.slice(0, 3).map((item) => (
          <div key={item.id}>
            <Badge
              status="error"
              text={`${item.UserName}`}
            />
          </div>
        ))}
        {items.length > 3 && (
          <div style={{ fontSize: '12px', color: '#999' }}>
            +{items.length - 3} คน
          </div>
        )}
      </div>
    );
  };

  const cellRender = (current, info) => {
    if (info.type === 'date') return dateCellRender(current);
    return info.originNode;
  };

  // เมื่อเปลี่ยน tab (shift)
  const onTabChange = (key) => {
    setActiveTab(key);
  };

  const handleHolidayModalOk = async(values) => {
    try {
      await createLeaveDay(values)
    } catch (error) {
      message.error(error.message)
    } finally {
      refetchSchedule()
      refetchListLeaveDay()
      setIsHolidayModalOpen(false);
    }
  };

  // Tabs สำหรับ Day/Night
  const tabItems = [
    {
      key: 'day',
      label: 'เช้า (Day)',
      children: (
        isLoading ? <Spin /> :
          <Calendar
            onPanelChange={(value) => {
              setSelectMonthDay(dayjs(value).format('YYYY-MM'));
            }}
            cellRender={cellRender}
          />
      ),
    },
    {
      key: 'night',
      label: 'คํ่า(Night)',
      children: (
        isLoading ? <Spin /> :
          <Calendar
            onPanelChange={(value) => {
              setSelectMonthNight(dayjs(value).format('YYYY-MM'));
            }}
            cellRender={cellRender}
          />
      ),
    },
    {
      key: 'afternoon',
      label: 'กลาง (Mix)',
      children: (
        isLoading ? <Spin /> :
          <Calendar
            onPanelChange={(value) => {
              setSelectMonthMix(dayjs(value).format('YYYY-MM'));
            }}
            cellRender={cellRender}
          />
      ),
    },
  ];

  return (
    <div className="md:m-10">
      <div className="flex justify-between mb-6">
        <Header category="App" title="ตารางวันหยุด" />
      </div>
      <Tabs defaultActiveKey="day" items={tabItems} onChange={onTabChange} />

      <div className="flex justify-between mb-6 mt-10">
        <Header category="App" title="ลาหยุดฉุกเฉิน" />
        <div style={{ marginLeft: "auto" }}>
          <Button
            onClick={() => setIsHolidayModalOpen(true)}
            className="bg-blue-500 text-white"
          >
            เพิ่ม
          </Button>
        </div>
      </div>
      <TableHoliday
        data={listLeaveDay}
        rowKey="id"
        pagination={false}
        size="small"
        loading={isLoadingListLeaveDay}
        refresh={refresh}
      />
      <HolidayModal
        visible={isHolidayModalOpen}
        onCancel={() => setIsHolidayModalOpen(false)}
        onOk={handleHolidayModalOk}
      />
    </div>
  );
}

export default SchedulePage;
